import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TEXT_CONSTANTS } from '../constance/constants';
import { environment } from '../../environments/environment';
import { InsightsService } from '../../services/appinsightsservice';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/apiservice';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EnrollmentResponseComponent } from '../enrollment-response/enrollment-response.component';
import { ToastModule } from 'primeng/toast';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
@Component({
  selector: 'app-report-outage',
  imports: [
    DropdownComponent,
    CommonModule,
    CardModule,
    FormsModule,
    ProgressSpinnerModule,
    EnrollmentResponseComponent,
    ToastModule,
    DialogModule
  ],
  templateUrl: './report-outage.component.html',
  styleUrl: './report-outage.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ReportOutageComponent implements OnInit {
  region: string = '';
  phoneMeterNumber: string = '';
  houseNumber: string = '';
  isEligible: boolean = false;
  isPhoneOrMeterValid: boolean = false;
  phoneOrMeterErrorMessage: string = '';
  houseNumberErrorMessage: string = '';
  isHouseNumValid: boolean = false;
  ispasLightPreferenceForm: boolean = false;
  acaptchaToken: string = '';
  siteKey = environment.recaptcha.siteKey;
  isLoading: boolean = false;
  customerIdentifierType: string = '';
  showPopup: boolean = false;
  apiResponse: any;
  emergencyNumber = '';
  showEopBlock = true;
  supportNumber: string = '';
  bannerContent!: SafeHtml;
  outageTypes = [
    { label: 'LS - Lights Out', value: 'LS' },
    { label: 'PS - Partial Service', value: 'PS' },
    { label: 'DL - Dim Lights', value: 'DL' },
  ];

  selectedOutageType: any = 'LS';

  textConstants = TEXT_CONSTANTS;
  bannerFlag: boolean = false;
  accountHelpVisible = false;
  accountHelpImage = '';
  accountHelpTitle = '';
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private insightsService: InsightsService,
    private messageService: MessageService,
    private titleService: Title,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Report Outage');
    this.route.params.subscribe((params) => {
      this.region = params['region'] ?? 'texas';

      const map = environment.supportNumbers as Record<string, string>;
      this.emergencyNumber =
        map[this.region.toLowerCase()] ?? map['default'] ?? '';
      this.supportNumber =
        environment.supportNumbers[
        this.region.toLowerCase() as keyof typeof environment.supportNumbers
        ] ?? environment.supportNumbers.default;

      this.updateEopVisibility();
    });
  }

  validateForm() {
    if (this.isPhoneOrMeterValid && this.isHouseNumValid) {
      this.ispasLightPreferenceForm = true;
    } else {
      this.ispasLightPreferenceForm = false;
    }
  }

  private getRecaptchaToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      if ((window as any).grecaptcha && (window as any).grecaptcha.enterprise) {
        (window as any).grecaptcha.enterprise.ready(() => {
          (window as any).grecaptcha.enterprise
            .execute(this.siteKey, { action: 'submit' })
            .then(
              (token: string) => {
                this.acaptchaToken = token;
                resolve(token);
              },
              (error: any) => reject(error),
            );
        });
      } else {
        reject(new Error('reCAPTCHA not loaded'));
      }
    });
  }

  onOutageTypeChange(value: string): void {
    this.selectedOutageType = value;
  }

  private updateEopVisibility(): void {
    let eopFLag = false;
    let isRegionTx = this.region.toLowerCase() === 'texas';
    this.apiService
      .get(environment.apiUrl + '/api/reportoutage/GetRPTPageDetails')
      .subscribe((data: any) => {
        if (data) {
          eopFLag = data.eopFlag.toLowerCase() === 'true';
          this.bannerFlag = isRegionTx
            ? data.bannerFlagTx === 'True'
            : data.bannerFlagIn === 'True';
          this.bannerContent = this.sanitizer.bypassSecurityTrustHtml(
            isRegionTx ? data.bannerContentTx : data.bannerContentIn,
          );

          // Indiana always show. Texas show only when EOP is false.
          if (this.region.toLowerCase() == 'indiana') {
            this.showEopBlock = false;
          } else {
            this.showEopBlock = !eopFLag;
          }

          if (!this.showEopBlock) {
            this.isEligible = true;
          }
        }
      });
  }

  validatePhoneOrMeterNumber(): boolean {
    let input = this.phoneMeterNumber.trim().toUpperCase();
    //check if it is a valid meter number
    const regex = /^[A-Za-z]\d{0,10}$/;
    if (regex.test(input)) {
      this.phoneMeterNumber = input;
      this.customerIdentifierType = 'M';
      this.phoneOrMeterErrorMessage = '';
      this.isPhoneOrMeterValid = true;
      this.validateForm();
      return true;
    }

    //else treat it as phone number and remove all non-numeric characters
    let cleanedInput = input.replace(/\D/g, '');
    this.phoneMeterNumber = cleanedInput;
    if (cleanedInput.length === 10) {
      this.customerIdentifierType = 'P';
      this.phoneOrMeterErrorMessage = '';
      this.isPhoneOrMeterValid = true;
      this.validateForm();
      return true;
    }
    this.isPhoneOrMeterValid = false;
    this.phoneOrMeterErrorMessage =
      this.region.trim().toUpperCase() === 'TEXAS'
        ? this.textConstants.ERROR_MESSAGES.INVALID_PHONEORMETERNUM_MESSAGETX
        : this.textConstants.ERROR_MESSAGES.INVALID_PHONEORMETERNUM_MESSAGEIN;
    this.validateForm();
    return false;
  }

  validateHouseNum(): boolean {
    this.houseNumber = this.houseNumber.replace(/[^a-zA-Z0-9]/g, '');
    if (!this.houseNumber.trim()) {
      this.isHouseNumValid = false;
      this.houseNumberErrorMessage =
        this.textConstants.ERROR_MESSAGES.REQUIRE_HOUSENUM_MESSAGE;
      this.validateForm();
      return false;
    }
    this.isHouseNumValid = true;
    this.houseNumberErrorMessage = '';
    this.validateForm();
    return true;
  }

  async onSubmit(form: NgForm, triggerEvent?: Event): Promise<void> {
    if (triggerEvent && !triggerEvent.isTrusted) {
      return;
    }

    try {
      await this.getRecaptchaToken();
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Failure',
        detail:
          'Unfortunately, your request could not be processed. Please try again.',
        life: environment.appSettings.snakbarLife,
      });
      return;
    }

    if (this.acaptchaToken) {
      const payload = {
        region: this.region.trim().toUpperCase() == 'TEXAS' ? 'TX' : 'IN',
        phoneMeterNumber: this.phoneMeterNumber,
        identifierType: this.customerIdentifierType,
        houseNumber: this.houseNumber,
        type: this.selectedOutageType,
        token: this.acaptchaToken,
      };

      this.insightsService.trackEvent(
        `reportOutageSubmit: ${JSON.stringify(payload)}`,
      );

      //Loading spinner set to true
      this.isLoading = true;

      this.apiService
        .post(environment.apiUrl + '/api/reportoutage/createoutage', payload)
        .subscribe({
          next: (data: any) => {
            this.insightsService.trackEvent(
              `createOutageResponse: ${JSON.stringify(data)}`,
            );
            //this.showPopup = true;
            const toastMessage = data.statusDescription
              ? data.statusDescription
              : environment.appMessages.unknownError + this.supportNumber;

            if (data.status == 'Success') {
              this.messageService.add({
                severity: 'success',
                summary: 'Outage reported successfully',
                detail: toastMessage,
                life: environment.appSettings.snakbarLife,
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Outage report failed',
                detail: toastMessage,
                life: environment.appSettings.snakbarLife,
              });
            }
            this.apiResponse = data;
            this.isLoading = false;
            this.refreshRecaptchaToken();
          },
          error: (error: any) => {
            console.error('API Error:', error);
            this.insightsService.trackEvent(
              `createOutageError: ${JSON.stringify(error)}`,
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Report Outage Failed',
              detail: environment.appMessages.unknownError + this.supportNumber,
              life: environment.appSettings.snakbarLife,
            });
            this.isLoading = false;
            this.refreshRecaptchaToken();
          },
        });
    } else {
      console.log("Token failure form Not Submitted");
      this.messageService.add({
        severity: 'error',
        summary: 'Failure',
        detail:
          'Unfortunately, your request could not be processed. Please try again.',
        life: environment.appSettings.snakbarLife,
      });
      this.refreshRecaptchaToken();
    }
  }

  handleSubmitButtonClick(event: MouseEvent, form: NgForm): void {
    if (!event.isTrusted) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    void this.onSubmit(form, event);
  }

  refreshRecaptchaToken(): void {
    this.showPopup = false;
    this.acaptchaToken = '';
  }

  openAccountHelp(helpType: 'meter' | 'street'): void {
    if (helpType === 'meter') {
      this.accountHelpImage = `../../assets/images/meternumber_${this.region.toLowerCase() === 'texas' ? 'tx' : 'in'}.jpg`;
      this.accountHelpTitle = 'Find Your Meter Number';
    } else {
      this.accountHelpImage = '../../assets/images/streetnumber.jpg';
      this.accountHelpTitle = 'Find Your Street Number';
    }
    this.accountHelpVisible = true;
  }
}
